export const environment = {
  production: false,
  GRAPHQL_URL: 'https://dev-radar-api.voyagu.app/portal/graphql',
  GRAPHQL_PROTECTED_URL: 'https://dev-radar-api.voyagu.app/a-portal/graphql',
  GRAPHQL_SCHEMA_URL: 'https://dev-radar-api.voyagu.app/portal/schema',
  BUILD_QUERY_KEY: '6a004d54ad43#14',
  STRIPE_PUBLIC_KEY: 'pk_test_51Qi55iCHkRl3qoiTSRNahz35UXhBCiAijYkvBUMO22kCRKx4gM6PdYMjCTdnoLpXbzMn5XCp4bpg8t9svuz9uUAt00Pm9N3mYY',
  CLOUDFRONT_API: 'https://d3hc0p9quv2wa0.cloudfront.net/develop/portal/graphql',
  TRACKING_URL: 'https://develop-tr.businessclassconsolidator.com',
  AWS_PROJECT_REGION: 'eu-central-1',
  AWS_COGNITO_REGION: 'eu-central-1',
  AWS_USER_POOLS_ID: 'eu-central-1_rv0HBBZOy',
  AWS_USER_POOLS_WEB_CLIENT_ID: '2af32uleuc8vdqrbkqnkkksjon',
  OAUTH_DOMAIN: 'develop-portal.auth.eu-central-1.amazoncognito.com',
  AMPLIFY_REDIRECT_SIGN_IN: 'https://develop-q.bcconsolidator.com/login',
  AMPLIFY_REDIRECT_SIGN_OUT: 'https://develop-q.bcconsolidator.com/logout',
  GOOGLE_FLIGHTS_URL: 'https://rmrjbqbiynmxhomgbh6zpdmvju0bfcpn.lambda-url.eu-central-1.on.aws/api/google_flights/search',
};